import { Container, Box, Typography, Grid, Button, Chip } from "@mui/material";
import CurrentOpeningSection from "./CurrectOpeningSection";
import UniformCard from "../../../components/UniformCard/UniformCard";
import { FaGlobe, FaRocket, FaAward, FaUsers } from "react-icons/fa";
import PageTitle from "../../../components/pagetitle/PageTitle";

const CurrentOpenings = () => {
  const themeColors = {
    primary: "var(--primary-color)",
    secondary: "var(--secondary-color)",
    lightBg: "#f8fbff",
    white: "#fff",
  };

  const benefits = [
    {
      icon: <FaRocket size={30} />,
      title: "Big opportunities, bigger growth.",
      subtitle: "Growth",
      description:
        "Work with some of the best in the industry in an inspiring environment with exposure across industries and business functions.",
    },
    {
      icon: <FaGlobe size={30} />,
      title: "One team working globally",
      subtitle: "Global",
      description:
        "Collaborate daily with experts from multiple locations, build international relationships, and explore cross-functional roles.",
    },
    {
      icon: <FaAward size={30} />,
      title: "ACCA Global Employer",
      subtitle: "ACCA",
      description:
        "Gain ACCA-accredited experience with on-the-job training, articleship support, and opportunities across multiple verticals.",
    },
  ];

  return (
    <Box sx={{ bgcolor: themeColors.lightBg, minHeight: "100vh" }}>
      {/* Hero Section */}
      <PageTitle
        pageTitle="Your Career Starts Here "
        pagesub="At Vdoogar, growth is a mindset. Join a team that is constantly evolving, innovating, and pushing boundaries."
      />

      {/* Benefits Section */}
      <Container sx={{ position: "relative", zIndex: 2, mt: 12, pb: 12 }}>
        <Box sx={{ mb: 8, textAlign: "center" }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              color: themeColors.primary,
              fontFamily: "'Roboto Slab', serif",
              mb: 2,
            }}
          >
            Why Work At Vdoogar?
          </Typography>
          <Box
            sx={{
              width: "80px",
              height: "4px",
              bgcolor: themeColors.primary,
              mx: "auto",
              borderRadius: "2px",
            }}
          />
        </Box>

        <Grid container spacing={4}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} md={4} key={index}>
              <UniformCard
                icon={benefit.icon}
                title={benefit.title}
                subtitle={benefit.subtitle}
                description={benefit.description}
              />
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* Vdoogar & You Section */}
      <Box
        sx={{
          bgcolor: "#fff",
          py: 12,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "40%",
            height: "100%",
            backgroundImage:
              "linear-gradient(to left, rgba(255,255,255,0.03), transparent)",
            zIndex: 0,
          }}
        />
        <Container>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box>
                <Typography
                  sx={{
                    color: "var(--primary-color)",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: 2,
                    mb: 1,
                  }}
                >
                  Vdoogar & You
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    color: "#222",
                    fontWeight: 800,
                    fontFamily: "'Roboto Slab', serif",
                    mb: 3,
                  }}
                >
                  Find your place in our global family
                </Typography>
                <Typography sx={{ color: "#555", fontSize: "1.1rem", mb: 4 }}>
                  Whether you are starting your career or looking for your next
                  big step, there is a role at Vdoogar that fits your ambitions.
                  Work with cross-cultural teams and build a career that adapts
                  with you.
                </Typography>
                <Box
                  sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, mb: 5 }}
                >
                  {[
                    "Consulting",
                    "Tax & Advisory",
                    "Audit & Assurance",
                    "Support Functions",
                  ].map((tag) => (
                    <Chip
                      key={tag}
                      label={tag}
                      sx={{
                        bgcolor: "rgba(26, 66, 161, 0.08)",
                        color: "var(--primary-color)",
                        border: "1px solid rgba(26, 66, 161, 0.2)",
                        fontWeight: 600,
                      }}
                    />
                  ))}
                </Box>
                <Button
                  variant="outlined"
                  href="#openings"
                  sx={{
                    color: "var(--primary-color)",
                    borderColor: "var(--primary-color)",
                    px: 4,
                    py: 1.5,
                    borderRadius: "8px",
                    fontWeight: 600,
                    "&:hover": {
                      borderColor: "var(--primary-color)",
                      bgcolor: "rgba(26, 66, 161, 0.05)",
                    },
                  }}
                >
                  See Opportunities
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  borderRadius: "24px",
                  overflow: "hidden",
                  boxShadow: "0 30px 60px rgba(0,0,0,0.3)",
                  transform: "rotate(2deg)",
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=600&fit=crop"
                  alt="Team collaboration"
                  style={{ width: "100%", height: "auto", display: "block" }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Current Openings Section */}
      <Box id="openings" sx={{ py: 12 }}>
        <Container>
          <Box sx={{ mb: 6, textAlign: "center" }}>
            <Typography
              variant="h3"
              sx={{
                fontWeight: 800,
                color: themeColors.primary,
                fontFamily: "'Roboto Slab', serif",
                mb: 2,
              }}
            >
              Current Openings
            </Typography>
            <Typography
              color="textSecondary"
              sx={{ fontSize: "1.1rem", maxWidth: "600px", mx: "auto" }}
            >
              Discover roles that match your skills, ambitions, and preferred
              location.
            </Typography>
          </Box>
          <CurrentOpeningSection />
        </Container>
      </Box>
    </Box>
  );
};

export default CurrentOpenings;
